<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
    body {
        margin: 0;
    }
    #app {
        width: 100%;
        height: 100%;
    }
    .rich-editor {
        line-height: 1em;
    }
    @import "styles/mixin";
    @import "../../commonsPC/styles/platform-global";

    @include reset-global;

    .platform-header {
         @include platform-header;

         .platform-logo-container {
             @include platform-logo-container;
         }
         .platform-nav {
             @include platform-nav;

         }
         .platform-user {
             @include platform-user;
         }
     }

    .module-container {
        margin-top: 90px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue